import Splide from '@splidejs/splide';
import { splideA11yOptions, fixSplideSlideRoles } from '@resources/js/splide-a11y';

const padNumber = (number) => {
    const paddedNumber = "0" + number;
    return paddedNumber.substring(paddedNumber.length - 2);
}

document.addEventListener('DOMContentLoaded', function() {
    const splideSelector = '.homepage-hero-splide.splide';
    if (document.querySelector(splideSelector)) {
        const splide = new Splide(splideSelector, {
            type: 'fade',
            rewind: true,
            autoplay: true,
            pauseOnHover: true,
            pauseOnFocus: true,
            interval: 6000,
            perPage: 1,
            pagination: false,
            arrows: true,
            lazyLoad: 'nearby',
            ...splideA11yOptions('Virtual museum carousel'),
        });

        const slides = document.querySelectorAll(`${splideSelector} .splide__slide:not(.splide__slide--clone)`);
        const customPageNumbers = document.querySelector(`${splideSelector} .splide__page-numbers`);

        const currentPage = customPageNumbers.querySelector('.splide-page-numbers__active');
        const totalPages = customPageNumbers.querySelector('.splide-page-numbers__total');

        const titles = document.querySelectorAll(`${splideSelector} .splide__title`);

        splide.on('move', (newIndex, prevIndex, destIndex) => {
            const nextSlide = slides[newIndex];
            const prevSlide = slides[prevIndex];

            nextSlide.classList.add('is-moving');
            prevSlide.classList.add('is-moving');
        });

        splide.on('moved', (newIndex) => {
            slides.forEach(slide => slide.classList.remove('is-moving'));
            titles.forEach(title => title.classList.remove('show'));

            titles[newIndex].classList.add(`show`);

            currentPage.innerText = padNumber(newIndex + 1);
        });

        splide.on('mounted', () => {
            currentPage.innerText = '01';
            totalPages.innerText = padNumber(slides.length);
        });

        fixSplideSlideRoles(splide);
        splide.mount();
    }
});